// Persist pooling answers so a rebuild does not ask twice; orientation changes require a full rebuild.
import { StudioDraft, StudioItem, StudioRunGeometry } from "../studioTypes";
import {
  BlockOrientation,
  CdtBuildReport,
  CdtLayoutOptions,
  buildFromCdt,
  poolingKeyOf,
} from "./buildFromCdt";
import { GeneratedLayout } from "../studioTypes";

export interface HierarchySwapRequest {
  /** The vertical-level attribute the value lives at (e.g. brand). */
  attr: string;
  value: string;
  orientation: BlockOrientation;
}

export interface HierarchySwapResult {
  layout: GeneratedLayout;
  report: CdtBuildReport;
  /** The draft's persisted pooling answers, updated with this one. */
  poolingOverrides: Readonly<Record<string, BlockOrientation>>;
}

export const applyHierarchySwap = (
  items: readonly StudioItem[],
  runs: readonly StudioRunGeometry[],
  draft: StudioDraft,
  request: HierarchySwapRequest,
  options: CdtLayoutOptions = {},
): HierarchySwapResult => {
  const poolingOverrides: Record<string, BlockOrientation> = {
    ...(draft.poolingOverrides ?? {}),
    [poolingKeyOf(request.attr, request.value)]: request.orientation,
  };
  const built = buildFromCdt(items, runs, draft, {
    ...options,
    identityAttr: options.identityAttr ?? request.attr,
    poolingOverrides,
  });
  return { ...built, poolingOverrides };
};
